<template>
  <div class="home">
    <router-link to="/login">登录登录</router-link>

    <van-field v-model="loginPhone" :placeholder="phonePlaceholder" clearable></van-field>
    <van-button type="primary" size="large" @click="getVerifyCode(loginPhone)">获取验证码</van-button>
    <van-field v-model="codeValue" :placeholder="codePlaceholder" clearable></van-field>

    <van-button type="primary" size="large" @click="phoneLogin(codeValue)">登录</van-button>

    <hr>

    <van-button type="primary" size="large" @click="checkLogin()">checkLogin</van-button>

    <hr>

    <van-button type="primary" size="large" @click="getBoughtList()">getBoughtList</van-button>

    <hr>

    <van-button type="primary" size="large" @click="getVipInfo()">getVipInfo</van-button>

    <hr>

    <van-button type="primary" size="large" @click="getLoginInfo()">getLoginInfo</van-button>

    <hr>

    <van-button type="primary" size="large" @click="WeChatLogin()">WeChat Login</van-button>

    <hr>

    <van-button type="primary" size="large" @click="logout()">logout</van-button>
  </div>
</template>

<script>
import { Button, Field } from 'vant';
import request from '@/plugins/axios';

export default {
  name: 'home',
  components: {
    [Button.name]: Button,
    [Field.name]: Field
  },
  data() {
    return {
      loginPhone: '',
      codeValue: '',
      phonePlaceholder: '手机号码',
      codePlaceholder: '验证码',
    };
  },
  created() {
    this.checkLogin();
  },
  methods: {
    phoneLogin(code) {
      const params = {
        phone: this.loginPhone,
        save_login: 1,
        mode: 'code-login',
        verify_code: code,
      };

      request.post('/api/user/login', params);
    },
    getVerifyCode(phone) {
      request.get('/api/user/send_verify_code', {
        params: {
          phone,
        },
      });
    },
    checkLogin() {
      request.get('/api/user/check_login');
    },
    getBoughtList() {
      request.get('/api/lesson/bought_list');
    },
    getVipInfo() {
      request.get('/api/user/vip_info');
    },
    getLoginInfo() {
      request.get('/api/user/login_info');
    },
    logout() {
      request.get('/live_/user/del_session');
    },
    WeChatLogin() {
      // eslint-disable-next-line no-unused-vars
      let wxLoginUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx581593f1bcbfaaa8&redirect_uri={redirect_uri}&response_type=code&scope=snsapi_base&state=2#wechat_redirect';

      const originUri = `https://api.yojiang.cn/api/weixin/login/oauth2?next=${window.location.href}`;

      const encodedUrl = encodeURIComponent(originUri);

      wxLoginUrl = wxLoginUrl.replace('{redirect_uri}', encodedUrl);
    },
  },
};
</script>

<style lang="stylus" scoped>
  .home {
    padding: 15px

  }
</style>
